'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Nextview = exports.Preview = exports.Preload = exports.Iframe = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @private
 */
var View = _styledComponents2.default.div.withConfig({
  displayName: 'views__View'
})(['--scale:var(--view-scale,1);position:relative;height:100%;width:100%;grid-area:View;box-shadow:0 3px 8px rgba(0,0,0,0.7);border-radius:3px;overflow:hidden;']);

exports.default = View;
var Iframe = exports.Iframe = _styledComponents2.default.iframe.withConfig({
  displayName: 'views__Iframe'
})(['transform-origin:0 0;width:calc(100% / var(--scale,1));height:calc(100% / var(--scale,1));transform:scale(var(--scale,1));']);

/**
 * @private
 */
var Preload = exports.Preload = _styledComponents2.default.div.withConfig({
  displayName: 'views__Preload'
})(['display:none;']);

/**
 * @private
 */
var Preview = exports.Preview = _styledComponents2.default.div.withConfig({
  displayName: 'views__Preview'
})(['--scale:var(--preview-scale,1);position:relative;height:100%;width:100%;grid-area:Preview;box-shadow:0 3px 8px rgba(0,0,0,0.7);border-radius:3px;overflow:hidden;']);

/**
 * @private
 */
var Nextview = exports.Nextview = _styledComponents2.default.div.withConfig({
  displayName: 'views__Nextview'
})(['', ';--scale:var(--nextview-scale);position:relative;height:100%;width:100%;grid-area:Nextview;box-shadow:0 3px 8px rgba(0,0,0,0.7);border-radius:3px;overflow:hidden;'], function (_ref) {
  var layout = _ref.layout;
  return layout === 0 ? '' : 'display: none';
});

/**
 * @private
 */
Nextview.propTypes = {
  layout: _propTypes2.default.number

  /**
   * @private
   */
};Nextview.defaultProps = {
  layout: 0
};